/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";

/**
 * Block of the details card: the icon that identifies the block on the left and
 * its sections on the right.
 */
const DetailsSectionRow = ({Icon, iconBackgroundClass, className = '', children}) => {
    return (
        <div className={`row ${className}`}>
            <div className='col-sm-12 col-md-2 p-0'>
                <div className={`${iconBackgroundClass} p-8px border-radius-8px d-flex justify-content-center`}>
                    <Icon width={24} height={24}/>
                </div>
            </div>
            <div className='col-sm-12 col-md-10'>
                {children}
            </div>
        </div>
    );
};

export default DetailsSectionRow;
